import { Controller, MobileContextMenu } from '@tencent/workbench';
import { AiGeneratePageMobile } from './ai-generate-page-mobile';
import { MOBILE_CONTEXTMENU_ITEMS, config } from './config';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { isCloudSlide } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';

/**
 * 移动端 - 旋转
 */
@Controller({
    mobileContextMenuItems: MOBILE_CONTEXTMENU_ITEMS,
})
export class AiGeneratePageMobileController {
    constructor(private readonly feature: AiGeneratePageMobile) {}

    @MobileContextMenu(config.name, 'onClick')
    public setFocus() {
        isCloudSlide();
        this.feature.getAppServices().editableServiceLayer?.aiFloatManager?.triggerGeneratePageMobile({});
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.PAGE_CREATE,
            action: TDWActionType.AI_CLK,
            ver5: TDWModuleType.MOBILE,
            ver6: '0',
        });
    }

    @MobileContextMenu(config.name, 'shouldHide')
    public shouldHide() {
        const { lastMouseDownRegion } = this.feature.getAppServices().viewableServiceLayer.selectionService;
        if (lastMouseDownRegion !== RegionType.EDITOR && lastMouseDownRegion !== RegionType.SLIDELIST) {
            return true;
        }

        const isPreviewMode = !this.feature.getAppServices().viewableServiceLayer.entryStateService.checkIfEditMode?.();
        if (isPreviewMode) {
            return true;
        }

        // ToggleConfig 对 AI-Float 的开关
        const EnabledByToggleConfig = (getToggleStatusByType(ToggleType.AI_FLOAT_BAR) ?? true);
        if (!(DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.aiGeneratePage) ?? false)
            || !EnabledByToggleConfig) {
            return true;
        }

        const model = this.feature.getSelectionService().selectedElements.getCurrentModel();
        return model.type !== UIModelType.EMPTY;
    }
}
